import { create } from 'zustand';

import { registerModalOccupant } from '@/shared/lib/modal';

export type RecordingShareModalActions = {
  close: () => void;
  open: (options?: { afterRender?: boolean }) => void;
  resetForRecording: (recordingId: null | string) => void;
  setDisabled: (disabled: boolean) => void;
  setPendingRecordingId: (recordingId: null | string) => void;
  setShareUrl: (url: string) => void;
};

export type RecordingShareModalState = {
  isAutoOpened: boolean;
  isDisabled: boolean;
  isOpen: boolean;
  pendingRecordingId: null | string;
  recordingId: null | string;
  shareUrl: string;
};

const initialState: RecordingShareModalState = {
  isAutoOpened: false,
  isDisabled: true,
  isOpen: false,
  pendingRecordingId: null,
  recordingId: null,
  shareUrl: '',
};

export const useRecordingShareModalStore = create<RecordingShareModalActions & RecordingShareModalState>((set) => ({
  ...initialState,
  close: () => set({ isAutoOpened: false, isOpen: false }),
  open: (options) => set({ isAutoOpened: Boolean(options?.afterRender), isOpen: true }),
  resetForRecording: (recordingId) =>
    set((state) => {
      if (recordingId === null) return initialState;
      if (state.recordingId === recordingId) return {};

      return { isDisabled: true, pendingRecordingId: null, recordingId, shareUrl: '' };
    }),
  setDisabled: (disabled) => set({ isDisabled: disabled }),
  setPendingRecordingId: (recordingId) => set({ pendingRecordingId: recordingId }),
  setShareUrl: (url) => set({ shareUrl: url }),
}));

registerModalOccupant(useRecordingShareModalStore);
